export function getCookie(key) {
  return localStorage.getItem('UDAN_EMS_' + key)
}
export function setCookie(key, value) {
  localStorage.setItem('UDAN_EMS_' + key, value)
}

export function removeCookie(key) {
  localStorage.removeItem('UDAN_EMS_' + key)
}
export function getToken(key) {
  return sessionStorage.getItem('UDAN_EMS_' + key)
}
export function setToken(key, value) {
  sessionStorage.setItem('UDAN_EMS_' + key, value)
}

export function removeToken(key) {
  sessionStorage.removeItem('UDAN_EMS_' + key)
}
export function getStorage(key) {
  return localStorage.getItem('UDAN_EMS_' + key)
}
export function setStorage(key, value) {
  localStorage.setItem('UDAN_EMS_' + key, value)
}

export function removeStorage(key) {
  localStorage.removeItem('UDAN_EMS_' + key)
}
export function getStationsId(key) {
  return sessionStorage.getItem('UDAN_EMS_' + key)
}
export function getEmsId(key) {
  return sessionStorage.getItem('UDAN_EMS_' + key)
}
export function setStationsId(key, value) {
  sessionStorage.setItem('UDAN_EMS_' + key, value)
}
export function setEmsId(key, value) { 
  sessionStorage.setItem('UDAN_EMS_' + key, value)
}
export function removeStationsId(key) {
  sessionStorage.removeItem('UDAN_EMS_' + key)
}
export function removeEmsId(key) {
  sessionStorage.removeItem('UDAN_EMS_' + key)
}
export function setCustomerId(key, value) {
  localStorage.setItem('UDAN_EMS_' + key, value)
}
export function removeCustomerId(key) {
  localStorage.removeItem('UDAN_EMS_' + key)
}
